<template>
  <div v-if="!cart.loading && customer.loaded">
    <button class="hidden product-cart lg:flex flex-col items-center justify-center p-3 pt-3.5 fixed top-1/2 -mt-12 end-0 z-40 shadow-900 rounded-l-xxl bg-cart-counter text-light text-sm font-normal transition-colors duration-200 focus:outline-none hover:bg-cart-counter-hover" @click="handleSidebarOpen">
      <span class="flex items-center pb-0.5">
        <ShoppingBagIcon class="w-5 h-5 flex-shrink-0" />
        <span class="flex ms-2">
            {{ formatString(cart.totalUniqueItems, $t("common:text-item")) }}
        </span>
      </span>
      <span class="bg-light rounded-xl w-full py-2 px-2 text-2xl text-primary-dark font-bold mt-3">{{ totalPrice }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { formatString } from "@utils/format-string";
import { useAuthStore } from '@stores/auth';
import { useCartStore } from '@stores/cart';
import { useSelectedStore } from '@stores/selected';
import { useCustomerStore } from '@stores/customer';
import usePrice from "@utils/use-price";
import ShoppingBagIcon from "@components/icons/shopping-bag-icon";

const auth = useAuthStore();
const cart = useCartStore();
const store = useSelectedStore();
const customer = useCustomerStore();

const totalPrice = computed(() => usePrice({
  amount: cart.total / (customer?.language?.currency?.currencyRate || 1),
  currencyCode: customer?.language?.currency?.code
}).price);

const { $eventBus } = useNuxtApp();

const handleSidebarOpen = () => {
    store.setAction(null);
    if (auth.isLoggedIn) {
      $eventBus.emit('sidebar:open', 'CART_VIEW');
    } else {
      $eventBus.emit('modal:open', 'LOGIN_VIEW');
    }
}

</script>
